import Cookies from 'js-cookie'
import { tabBar } from '@/config/navbar'

const state = {
  tabBar
}

const mutations = {
  SET_TABBAR: (state, tabBar) => {
    state.tabBar = tabBar
  }
}

const actions = {
  changeSideBar({ commit }) {
    commit('SET_TABBAR')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
